import { TACO0 } from "./TACO0";
import { BONGO, FunTitle } from "./TACOG";
import center_ring from 'url:../../assets/taco/Center Ring.png';

export function TACOB () {
    return <div className='taco-box width-768 height-512 h-box padding-32'>
        <div className="v-box width-192">
            <FunTitle title="MEET BONGO!" />
            <p className='font-taco-primary text-black text-20 padding-8'>
                This is Bongo! He's our crier straight to Clown Alley! 
                A barrel of laughs and a drum of a dog.
                Our witty whimsical tail-wagging 
                woebegone wisecracker wants 
                Taco Bongo SO wuch.
                <br/> <br/>
                Don't let his wails fool you, 
                he wants to be here! Get him 
                inside a Taco Bongo, and he'll 
                wolf it all down!
            </p>
        </div>
        <div className="pos-rel">
            <img className="pos-abs width-768" src={center_ring} />
            <div className="pos-abs" style={{ left: 200, top: 140}}>
                <BONGO height={256} />
            </div>
        </div>
    </div>
}